// src/components/products/BrandSidebar.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const BrandSidebar = ({
  brands,
  subCategories,
  selectedBrandId,
  selectedSubCategoryId,
  sidebarTitle,
  setSelectedBrandId,
  setSelectedSubCategoryId,
  safeText,
}) => {
  const navigate = useNavigate();

  return (
    <aside className="lg:w-64 xl:w-72 lg:sticky lg:top-24 lg:self-start">
      <div className="product-panel-elevated backdrop-blur-md rounded-2xl shadow-xl p-4 md:p-5 lg:p-6">
        <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4 md:mb-5">
          {safeText(sidebarTitle) || "Products"}
        </h2>
        <div className="space-y-2">
          {brands.map((brand) => {
            const isActiveBrand = brand.id === selectedBrandId;
            const brandSubs = subCategories.filter(
              (sub) => sub?.type && brand?.name && sub.type === brand.name
            );

            return (
              <div key={brand.id}>
                <button
                  type="button"
                  onClick={() => {
                    const targetUrl =
                      typeof brand.url === "string" && brand.url.trim()
                        ? brand.url
                        : "/products";
                    navigate(targetUrl);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-xl text-sm md:text-base ${
                    isActiveBrand
                      ? "product-sidebar-active"
                      : "product-sidebar-inactive"
                  }`}
                >
                  {safeText(brand.name)}
                </button>

                {/* Sub-category list under brand (type === brand.name) */}
                {isActiveBrand && brandSubs && brandSubs.length > 0 && (
                  <div className="product-sidebar-sub-group mt-3 pl-3">
                    <nav
                      className="product-sidebar-sub-list product-panel-nested"
                      aria-label={`${safeText(brand.name)} sub-categories`}
                    >
                      {brandSubs.map((sub) => {
                        const isActiveSub = sub.id === selectedSubCategoryId;

                        // Find the corresponding list item URL from Product Category's list
                        // Match sub-category name with list item title
                        let targetUrl = null;
                        if (brand.list && Array.isArray(brand.list)) {
                          const matchingItem = brand.list.find((item) => {
                            const itemTitle = safeText(item.title);
                            const subName = safeText(sub.name);
                            return item.url && itemTitle === subName;
                          });
                          if (matchingItem && matchingItem.url) {
                            targetUrl = matchingItem.url;
                          }
                        }

                        return (
                          <button
                            key={sub.id}
                            type="button"
                            onClick={() => {
                              if (targetUrl) {
                                navigate(targetUrl);
                              } else {
                                // Fallback: just set state without navigation
                                setSelectedBrandId(brand.id);
                                setSelectedSubCategoryId(sub.id);
                              }
                            }}
                            className={`product-sidebar-sub-item w-full text-left px-3 py-2.5 md:py-3 text-xs md:text-sm leading-snug transition-all duration-200 ${
                              isActiveSub
                                ? "product-sidebar-sub-active"
                                : "product-sidebar-sub-inactive"
                            }`}
                          >
                            {safeText(sub.name)}
                          </button>
                        );
                      })}
                    </nav>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default BrandSidebar;

